// test2639
(2639 && 0);
